import type { FC } from 'react';
import { useId, useState } from 'react';
import { useTranslation } from 'react-i18next';
import TextInput from '@wix/da-ds/pkg/formControls/dsPresets/TextInput';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import IconButton from '@wix/da-ds/pkg/Buttons/IconButton';
import CopyIcon from '@wix/da-ds/pkg/Icons/16x16/Copy';
import { useCopyToClipboard } from '@wix/da-shared-react/pkg/utils/hooks/useCopyToClipboard';

interface Props {
  value: string;
}

const ClientSecretField: FC<Props> = ({ value }) => {
  const { t } = useTranslation();
  const id = useId();
  const copyToClipboard = useCopyToClipboard(value);
  const [showSecret, setShowSecret] = useState(false);

  return (
    <TextInput
      id={id}
      label="client_secret"
      value={showSecret ? value : '*'.repeat(16)}
      postfix={
        showSecret ? (
          <IconButton
            icon={CopyIcon}
            size="small"
            aria-labelledby={id}
            onClick={ev => {
              ev.preventDefault();
              copyToClipboard();
            }}
          />
        ) : (
          <TextButton
            size="small"
            variant="main"
            priority="secondary"
            onClick={ev => {
              ev.preventDefault();
              setShowSecret(!showSecret);
            }}
          >
            {t('studio.apps.clientSecret.show')}
          </TextButton>
        )
      }
      noBottomSpacing
    />
  );
};
ClientSecretField.displayName = 'ClientSecretField';

export default ClientSecretField;
